<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button
        type="primary"
        @click.native="RestartOrder"
        :disabled="data.Status == 2 || !canWrite"
        >新增</el-button
      >
      <!-- 选单 -->
      <el-button
        type="primary"
        @click.native="toggleOrder"
        :disabled="data.Status == 2 || !canWrite"
        >单据选择</el-button
      >
      <el-button
        type="primary"
        @click.native="save"
        :disabled="(data.Status == 2 && !is_orderUpdateStatus) || !canWrite"
        >保存</el-button
      >
      <el-button
        type="primary"
        @click.native="orderUpdate"
        :disabled="data.Status != 2 || !canWrite"
        >变更</el-button
      >
      <el-button
        type="primary"
        @click.native="orderDel"
        :disabled="!isSave || data.Status == 2 || !canWrite"
        >删除</el-button
      >
      <el-button
        type="primary"
        @click.native="orderReview"
        :disabled="!isSave || !canReview"
        >{{ ReviewName }}</el-button
      >
      <!-- 联查 -->
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave">
          联查<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <!-- <el-dropdown-item class="dropdown-item">开票情况</el-dropdown-item> -->
          <el-dropdown-item class="dropdown-item" @click.native="goJump(1)"
            >销售出库单</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item" @click.native="goJump(2)"
            >收款单</el-dropdown-item
          >
          <el-dropdown-item class="dropdown-item" @click.native="goJump(3)"
            >销售订单</el-dropdown-item
          >
          <!-- <el-dropdown-item class="dropdown-item">退货情况</el-dropdown-item>
          <el-dropdown-item class="dropdown-item">凭证情况</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="openPrint" :disabled="!isSave"
        >打印</el-button
      >
    </div>
    <el-form
      :inline="true"
      :model="data"
      :line-form="true"
      label-width="90px"
      ref="ruleForm"
      :rules="rules"
      status-icon
    >
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="DocDate" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            $commonJs.toDateString(data.DocDate)
          }}</span>
          <el-date-picker
            v-else
            v-model="data.DocDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 190px"
            :clearable="false"
            @change="(val) => previewNo(val)"
          />
        </el-form-item>
        <el-form-item label="单据编码:" prop="DocNo" label-width="90px">
          <span
            v-if="Mode == 0 || ReviewStatus"
            class="not-edit"
            style="min-width: 190px"
            >{{ data.DocNo }}</span
          >
          <el-input
            v-else
            v-model="data.DocNo"
            placeholder="请输入单据编码"
            style="min-width: 190px"
          />
        </el-form-item>
        <!-- 业务类型 -->
        <el-form-item label="业务类型:" label-width="90px">
          <span class="not-edit" style="width: 190px" v-if="ReviewStatus">{{
            data.BusinessType
          }}</span>
          <el-select v-else v-model="data.BusinessTypeId" style="width: 190px">
            <el-option
              @click.native="BusinessChange(item)"
              v-for="item in businessTypeList"
              :key="item.BusinessTypeId"
              :label="item.BusinessType"
              :value="item.BusinessTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户:" prop="TradeUnitId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.FullName }}</span>
          <!-- <select-input
            v-else
            placeholder="请选择客户"
            :label="data.FullName"
            v-model="data.TradeUnitId"
            @click="openTradeunit"
            :clearable="!isSelect"
            :disabled="isSelect"
          /> -->
          <el-select
            v-else
            v-model="data.TradeUnitId"
            :clearable="!isSelect"
            :disabled="isSelect"
            filterable
            style="width: 190px"
          >
            <el-option
              v-for="item in tradeUnitList"
              :key="item.TradeUnitId"
              :value="item.TradeUnitId"
              :label="item.FullName"
              @click.native="setTradeunit(item)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款方式:" label-width="90px">
          <template v-if="ReviewStatus">
            <span class="not-edit" v-if="data.SettleId === 1">全额定金</span>
            <span class="not-edit" v-else-if="data.SettleId === 2">全额现结</span>
            <span class="not-edit" v-else-if="data.SettleId === 3">限期付款</span>
            <span class="not-edit" v-else-if="data.SettleId === 4">月结</span>
            <span class="not-edit" v-else-if="data.SettleId === 5">其他</span>
            <span class="not-edit" v-else></span>
          </template>
          <el-select v-else v-model="data.SettleId" style="width: 190px">
            <!-- <el-option v-for="item in serviceList" :key="item.id" :value="item.id" :label="item.name"></el-option>
             -->
            <el-option :value="1" label="全额定金" />
            <el-option :value="2" label="全额现结" />
            <el-option :value="3" label="限期付款" />
            <el-option :value="4" label="月结" />
            <el-option :value="5" label="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="收款到期日:" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.ExpiringDate
          }}</span>
          <el-date-picker
            v-else
            v-model="data.ExpiringDate"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            style="width: 190px"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="票据类型:" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{
            data.InvoiceTypeName
          }}</span>
          <invoice-select
            v-else
            @getInvoiceTypeValue="getInvoiceType"
            v-model="data.InvoiceTypeId"
            style="width: 190px"
          ></invoice-select>
        </el-form-item>

        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="EmpId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.EmpName }}</span>
          <select-input
            v-else
            placeholder="请选择经办人"
            :label="data.EmpName"
            v-model="data.EmpId"
            @click="openEmp"
            style="width: 190px"
          />
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:" label-width="90px">
          {{ data.MakeEmpName }}
        </el-form-item>
      </el-row>
      <!--  -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" label-width="90px">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input
              v-else
              type="textarea"
              v-model="data.Remark"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="60"
              placeholder="请填写备注信息"
              style="width: 600px"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <!--  -->
      <el-row style="margin: 0px 0 20px">
        <el-table
          border
          :data="tableList"
          class="tableList"
          :row-class-name="tableRowClassName"
          @row-click="addColumn"
          v-keymove="addList"
        >
          <insert-row @on-insert="onInsert" />
          <!-- <el-table-column align="center" label="条形码" min-width="140px">
            <template slot-scope="{ row }">
              <vue-barcode
                :value="row.ProductNo"
                width="1"
                height="20"
                fontSize="10"
              ></vue-barcode>
            </template>
          </el-table-column> -->
          <el-table-column min-width="160" align="left" label="备注">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.Remark }}</span>
              <el-input
                v-else
                v-model="row.Remark"
                @change="editT(row)"
                placeholder="请输入备注"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货名称" min-width="120px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.ProductName }}</span>
              <account-select
                v-else
                v-model="row.ProductName"
                :source="DAccount"
                @select="onSelect($event, row)"
                :pageSize="pageParams.pageSize"
                :pageIndex="pageParams.pageIndex"
                :listTotal="listTotal"
                @inputText="inputText"
                @click.native="resetFun"
                @currentPage="currentPage"
                :pageType="true"
              />
            </template>
          </el-table-column>
          <el-table-column align="left" label="存货编码" min-width="140px">
            <template slot-scope="{ row }">
              <span>{{ row.ProductNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="规格型号">
            <template slot-scope="{ row }">
              <span>{{ row.ProductSpec }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="颜色" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="row.SourceDocNo && !row.ColorId">{{
                row.ColorName || ""
              }}</span>
              <el-select
                v-else-if="row.UseColor && !ReviewStatus"
                v-model="row.ColorId"
                @change="changeColor(row, $index)"
              >
                <el-option
                  v-for="item in row.Colors"
                  :key="item.ColorId"
                  :value="item.ColorId"
                  :label="item.ColorName"
                  :disabled="item.Status==0"
                />
              </el-select>
              <span v-else>{{ row.ColorName }}</span>
            </template>
          </el-table-column>

          <!-- <el-table-column align="center" label="仓库" min-width="150px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{ row.WarehouseName }}</span>
              <wms-select
                v-else
                v-model="row.WarehouseId"
                @change="changWarehouse(row)"
              ></wms-select>
            </template>
          
          </el-table-column> -->
          <el-table-column align="left" label="销售单位" min-width="120px">
            <template slot-scope="{ row, $index }">
              <el-select
                v-if="row.Units && row.Units.length > 0 && !ReviewStatus&& row.HasGrammage != true"
                v-model="row.SaUnitId"
              >
                <el-option
                  v-for="item in row.Units"
                  :key="item.UnitId"
                  :value="item.UnitId"
                  :label="item.UnitName"
                  @click.native="compareSaUnit(item, row, $index)"
                ></el-option>
              </el-select>
              <span v-else>{{ row.SaUnitName }}</span>
            </template>
            <!--  -->
          </el-table-column>
          <el-table-column align="right" label="现存量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.StockQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="可用量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity)) }}</span>
            </template>
          </el-table-column>

          <!--  -->
          <el-table-column align="right" label="数量" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.SaQuantity)
              }}</span>
              <el-input
                v-else
                v-quantity:[option]="option"
                type="text"
                v-model="row.SaQuantity"
                @change="changeQuantity($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="left" label="计量单位2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <!-- <span>{{ row }}{{ $index }}</span> -->
              <el-select
                v-if="row.Units && row.Units.length > 0 && !ReviewStatus&& row.HasGrammage != true"
                v-model="row.UnitId2"
              >
                <el-option
                  v-for="item in row.Units"
                  :key="item.UnitId"
                  :value="item.UnitId"
                  :label="item.UnitName"
                  @click.native="compareUnitId(item, row, $index)"
                ></el-option>
              </el-select>
              <span v-else-if="row.UnitType == 0"></span>
              <span v-else>{{ row.UnitName2 }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="数量2" min-width="120px">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.Quantity2)
              }}</span>
              <span v-else-if="row.UnitType == 0"></span>
              <el-input
                v-else
                v-quantity:[option]="option"
                type="text"
                v-model="row.Quantity2"
                @change="changeQuantity2($event, row, $index)"
                @blur="getChangeQuantity($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="换算率">
            <template slot-scope="{ row, $index }">
              <span
                v-if="
                  (ReviewStatus || row.ChangeType == 0) && row.UnitType == 1
                "
                >{{ row.Rate }}</span
              >
              <span v-else-if="row.UnitType == 0"></span>
              <el-input
                v-else
                type="text"
                v-model="row.Rate"
                @input="RateChange($event, row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            label="最新含税进价"
            min-width="120px"
          >
            <template slot-scope="{ row }">
              <span>{{ row.PurchasePrice }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="right" label="最低售价" v-if="canPrice">
            <template slot-scope="{ row }">
              <span>{{ row.RetailPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.QuotedPrice }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.QuotedPrice"
                :disabled="row.IsGift"
                @change="changeQuotedPrice(row, $index)"
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Discount }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.Discount"
                :disabled="row.IsGift"
                @input="changeDiscount(row, $index)"
              />
            </template>
          </el-table-column>
          <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
              <el-input
                v-else
                v-decimals
                v-limit:value="{ max: 100, min: 0 }"
                type="text"
                v-model.number="row.TaxRate"
                :disabled="row.IsGift"
                @input="changeTaxRate(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="单价" min-width="140px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.Price"
                :disabled="row.IsGift"
                @change="changePrice(row, $index)"
              >
                <el-button
                  v-if="row.ProductName"
                  slot="append"
                  @click="openSales(row, $index)"
                  icon="el-icon-s-order"
                ></el-button>
              </el-input>
            </template>
            <!-- <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.Price }}</span>
              <el-input
                v-else
                v-price
                 type="text"
                v-model="row.Price"
                :disabled="row.IsGift"
                @input="changePrice(row, $index)"
              ></el-input>
            </template> -->
          </el-table-column>
          <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
              <el-input
                v-else
                v-price
                type="text"
                v-model="row.TaxPrice"
                :disabled="row.IsGift"
                @input="changeTaxPrice(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.Amount)
              }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.Amount"
                :disabled="row.IsGift"
                @input="changeAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="税额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.TaxLimit)
              }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxLimit"
                :disabled="row.IsGift"
                @input="changeTaxLimit(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="含税金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.TaxAmount)
              }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.TaxAmount"
                :disabled="row.IsGift"
                @input="changeTaxAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column align="right" label="折扣金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row, $index }">
              <span v-if="ReviewStatus">{{
                $commonJs.toThousands(row.DiscountAmount)
              }}</span>
              <el-input
                v-else
                v-decimals
                type="text"
                v-model="row.DiscountAmount"
                :disabled="row.IsGift"
                @input="changeDiscountAmount(row, $index)"
              ></el-input>
            </template>
          </el-table-column>
          <!--  -->
          <!-- <el-table-column align="center" label="成本价">
            <template slot-scope="{ row }">
              <el-input  type="text" v-model="row.CostPrice"></el-input>
            </template>
          </el-table-column>
          <el-table-column align="center" label="成本金额">
            <template slot-scope="{ row }">
              <el-input  type="text" v-model="row.CostAmount"></el-input>
            </template>
          </el-table-column> -->
          <!--  -->
          <el-table-column align="left" label="交货日期" min-width="180px">
            <template slot-scope="{ row }">
              <span v-if="ReviewStatus">{{
                $commonJs.toDateString(row.DeliveryDate)
              }}</span>
              <el-date-picker
                v-else
                v-model="row.DeliveryDate"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
                style="width: 140px"
                @change="changeDeliveryDate(row)"
              >
              </el-date-picker>
            </template>
          </el-table-column>
          <el-table-column align="center" label="赠品">
            <template slot-scope="{ row }">
              <el-checkbox
                @change="changeIsGift($event, row)"
                v-model="row.IsGift"
                :disabled="ReviewStatus"
              ></el-checkbox>
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="行中止">
            <template slot-scope="{ row }">
              <el-checkbox
                v-model="row.LineAbort"
                @change="changeLineAbort($event, row)"
                :disabled="isLineAbort || orderUpdateStatus"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column align="center" label="中止人">
            <template slot-scope="{ row }">
              <span>{{ row.LineAbortEmpName }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="中止时间" min-width="100px">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="right" min-width="100px" label="累计出库数量">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.OutQuantity)) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="right"
            min-width="100px"
            label="累计出库数量2"
          >
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(getQuantity(row.OutQuantity2)) }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            align="center"
            label="累计开票数量"
            min-width="120px"
          >
            <template slot-scope="{ row }">
              <span>{{ row.InvoicedQuantity }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="累计开票数量2"
            min-width="120px"
          >
            <template slot-scope="{ row }">
              <span>{{ row.InvoicedQuantity2 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="普通退货数量"
            min-width="100px"
          >
            <template slot-scope="{ row }">
              <span>{{ row.ReturnQuantity }}</span>
            </template>
          </el-table-column> -->
          <el-table-column align="right" label="累计结款金额" min-width="100px" v-if="canPrice">
            <template slot-scope="{ row }">
              <span>{{ $commonJs.toThousands(row.SettlementAmount) }}</span>
            </template>
          </el-table-column>
          <el-table-column align="right" label="销售订单号" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ row.OrderNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单据" min-width="100px">
            <template slot-scope="{ row }">
              <span v-if="row.SourceType === 8">销货单</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="来源单号" min-width="180px">
            <template slot-scope="{ row }">
              <span>{{ row.SourceDocNo }}</span>
            </template>
          </el-table-column>
          <el-table-column align="left" label="价格策略类型" min-width="100px">
            <template slot-scope="{ row }">
              <span v-if="row.PriceStrategyId == 0">销售价</span>
              <span v-if="row.PriceStrategyId == 1">折扣价</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="操作" v-if="!ReviewStatus">
            <template slot-scope="{ row, $index }">
              <el-button
                v-if="$permission.canWrite('/business/sales/quotation')"
                type="text"
                @click.stop="delTableList(row, $index)"
                >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 190px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 190px">
          {{ data.UpdateEmpName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.UpdateDate) }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <order-dialog ref="orderDialog" @save="initerPrice" in-dialog />
    <sale-select
      ref="saleSelect"
      in-dialog
      selectable
      multiple
      @select-multiple="setOrderList"
      :ordertype="ordertype"
    />

    <print-dialog
      ref="printDialog"
      :columns="columns"
      :data="columnData"
      :form-data="formData"
    ></print-dialog>
    <tradeunit-dialog
      ref="tradeunitDialog"
      in-dialog
      selectable
      @select="setTradeunit"
    />
  </div>
</template>
<script>
import VueBarcode from "vue-barcode";
import curdMixins from "@/mixins/trend/curd";
import empDialog from "@/components/personnel/result/record/listDialog";
import orderDialog from "@/components/business/sales/sale/priceDialog";
import printDialog from "@/components/common/printDialog/printDialog";
import accountSelect from "@/components/business/sales/select";
import saleSelect from "@/components/business/sales/sale/listDialog";
import deliveryReleaseSelect from "@/components/business/sales/deliveryrelease/info/listDialog";
// import list from "@/components/business/purchase/inquiry/list";
import saleList from "@/data/business/sales/sale/edit/list.json";
import optionMixins from "@/mixins/option";

import settle from "@/components/basedata/finance/settle/select";
import invoiceSelect from "@/components/basedata/finance/invoice/select";
import wmsSelect from "@/components/basedata/basedoc/wms/select";
import businessSelect from "@/components/basedata/basedoc/business/select";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
export default {
  name: "editSaleInvoice",
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialog,
    accountSelect,
    VueBarcode,
    printDialog,
    saleSelect,
    deliveryReleaseSelect,
    settle,
    invoiceSelect,
    wmsSelect,
    businessSelect,
    tradeunitDialog,
  },
  data() {
    return {
      api: require("@/api/sa/docInvoice").default,
      pdApi: require("@/api/ba/product").default,
      productApi: require("@/api/sa/quotation").default,
      tradeUnitApi: require("@/api/ba/tradeUnit").default,
      transportApi: require("@/api/ba/transport").default,
      code_api: require("@/api/sy/serialCode").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      initDAccount: [],
      initTotal: 0,
      DAccount: [],
      formData: [],
      columnkey: [],
      columns: [],
      columnData: [],
      colorList: [],
      listTotal: 0,
      isSelect: false, // 是否有选单的操作
      tableColorShow: true,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      ordertype:"销售发票",
      data: {
        DocId: 0,
        DocNo: "",
        DocDate: this.$commonJs.getToday(),
        BusinessTypeId: null,
        TradeUnitId: null,
        SettleId: null,
        ExpiringDate: "",
        Remark: "",
        EmpId: 0,
        DpId: 0,
        InvoiceTypeId: null,
        InvoiceNo: "",
        InvoiceAmount: 0,
        Amount: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        ReceiptAmount: 0,
        ShowTax: 0,
        DisposeTax: 0,
        Status: 0,
        OutStatus: 0,
        ReceiptStatus: 0,
        CompleteStatus: 0,
        ExecStatus: 0,
        CompletionDate: "",
        MakeEmpId: 0,

        ReviewEmpId: 0,
        ReviewDate: "",
        UpdateEmpId: 0,
        UpdateDate: "",

        BusinessType: "",
        InvoiceTypeName: "",
        SettleName: "",
        TradeUnitNo: "",
        TradeUnitType: 0,
        ShortName: "",
        FullName: "",
        DpName: "",
        EmpName: "",
        MakeEmpName: "",
        ReviewEmpName: "",
        UpdateEmpName: "",
        ProductModels: [],
      },
      isMainUnitId2: false,
      Mode: 0,
      isSave: false,
      tabPosition: "",
      reach: "联查",
      handledBy: "",
      preparedBy: "",
      IsGift: false,
      service: null,
      businessTypeList: [],
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      rules: {
        DocDate: [
          { required: true, message: "单据日期不能为空", trigger: "blur" },
        ],
        DocNo: [
          { required: true, message: "单据编码不能为空", trigger: "blur" },
        ],
        BusinessTypeId: [
          { required: true, message: "业务类型不能为空", trigger: "blur" },
        ],
        TradeUnitId: [
          { required: true, message: "客户不能为空", trigger: "change" },
        ],
        Address: [
          { required: true, message: "送货地址不能为空", trigger: "blur" },
        ],
        TransportId: [
          { required: true, message: "运输方式不能为空", trigger: "blur" },
        ],
        EmpId: [{ required: true, message: "经手人不能为空", trigger: "blur" }],
        Remark: [{ required: true, message: "备注不能为空", trigger: "blur" }],
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true,
      },
    };
  },
  computed: {
    orderUpdateStatus() {
      return this.data.Status == 2 && !this.is_orderUpdateStatus ? true : false;
    },
    ReviewName() {
      return this.data.Status == 2 ? "弃审" : "审核";
    },
    isLineAbort() {
      return this.data.DocId > 0 && this.data.ProductModels.length > 0
        ? false
        : true;
    },
    ReviewStatus() {
      return this.data.Status == 2 ? true : false;
    },
    canPrice() {
      return this.$permission.canPrice("/business/sales/saleinvoice");
    },
    canWrite() {
      return this.$permission.canWrite("/business/sales/saleinvoice");
    },
    canReview() {
      return this.$permission.canReview("/business/sales/saleinvoice");
    },
  },

  mounted() {
    this.init();
    // this.api.list({}).then((res) => (this.productList = res.Data));
    if (this.$route.params.isSave) this.isSave = true;
    if (this.$route.params.mode == "create" || !this.$route.params.mode) {
      this.createOrder();
    }
    console.log("触发编辑");
    if (this.$route.params.mode == "edit") {
      this.editOrder(this.$route.params.data.DocId);
    }
    if (this.$route.params.mode == "details") {
      this.editOrder(this.$route.params.data.DocId);
    }
  },
  methods: {
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId;
      this.data.MinusEntry = val.MinusEntry;
      this.data.BusinessType = val.BusinessType;
      this.changeNumber(this.data.MinusEntry);
    },
    changeNumber(status) {
      if (status) {
        this.tableList.forEach((item, index) => {
          if(item.ProductId > 0 && item.SaQuantity != null && item.SaQuantity !== ''){
            item.SaQuantity= item.SaQuantity > 0 ? 0-item.SaQuantity : item.SaQuantity;
            item.Quantity2= item.Quantity2 > 0 ? 0-item.Quantity2 : item.Quantity2;
            this.changeQuantity(item.SaQuantity, item, index, 0);
            //this.changeQuantity2(item.Quantity2, item, index, 0);
          }
        });
      } else {
        this.tableList.forEach((item, index) => {
          if(item.ProductId > 0 && item.SaQuantity != null && item.SaQuantity !== ''){
            item.SaQuantity = Math.abs(item.SaQuantity);
            item.Quantity2 = Math.abs(item.Quantity2);
            this.changeQuantity(item.SaQuantity, item, index, 0);
            //this.changeQuantity2(item.Quantity2, item, index, 0);
          }
        });
      }
    },
    onInsert(e) {
      let { type, index } = e;

      this.interpolate(null, index, type);
    },
    //获取默认选中第一个业务类型
    getBusinessTypeId(info) {
      this.data.BusinessTypeId = info;
    },
    async goJump(index) {
      let params = {};
      let ids = [];
      let res = null;
      switch (index) {
        case 1:
          res = await this.sourceTypeApi.info("销货单");
          params.SourceType = res.SourceTypeId;

          ids = this.data.ProductModels.filter((item) => {
            return item.SourceType === res.SourceTypeId;
          }).map((item) => {
            return item.SourceDocId;
          });

          if (ids.length === 0) {
            this.$message.error("单据未引用销货单，无法进行联查");
          } else {
            params.SourceIds = ids;
            this.$router.push({ name: "selloutwarehouse", params: params });
          }
          break;
        case 2:
          params.SourceDocId = this.data.DocId;
          res = await this.sourceTypeApi.info("销售发票");
          params.SourceType = res.SourceTypeId;
          this.$router.push({ name: "receivables", params: params });
          break;
        case 3:
          ids = this.data.ProductModels.filter((item) => {
            return item.SourceType === 8;
          }).map((item) => {
            return item.OrderId;
          });
          if (ids.length === 0) {
            this.$message.error(
              "单据未引用销货单，因此没有销货单的销售订单，无法进行联查"
            );
          } else {
            res = await this.sourceTypeApi.info("销货单");
            params.SourceType = res.SourceTypeId;
            params.Ids = ids;
            this.$router.push({ name: "saleorder", params: params });
          }

          break;
      }
    },
    interpolate(row, index, type = "") {
      let o = {
        T: 0,
        DocProductId: 0,
        ExistQuantity: 0,
        StockQuantity: 0,
        SourceDocId: 0,
        SourceDtsId: 0,
        SourceType: 0,
        OrderId: 0,
        OrderProductId: 0,
        WarehouseId: null,
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: 0,
        UnitId2: null,
        Quantity2: 0,
        Rate: 0,
        QuotedPrice: 0,
        Discount: 0,
        TaxRate: 0,
        Price: 0,
        TaxPrice: 0,
        Amount: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        DiscountAmount: 0,
        DeliveryDate: "",
        IsGift: false,
        CostPrice: 0,
        CostAmount: 0,
        OutQuantity: 0,
        OutQuantity2: 0,
        InvoicedQuantity: 0,
        InvoicedQuantity2: 0,
        ReturnQuantity: 0,
        SettlementAmount: 0,
        PriceStrategyId: 0,
        ReceiptAmount: 0,
        DocNo: "",
        DocDate: "",
        ColorName: "",
        ProductNo: "",
        ProductType: 0,
        ProductName: "",
        ShortName: "",
        ProductSpec: "",
        Property: "",
        UnitName2: "",
        SaUnitName: "",
        OrderNo: "",
        WarehouseName: "",
        WarehouseNo: "",
        InvoiceTypeName: "",
        TradeUnitId: 0,
        TradeUnitNo: "",
        FullName: "",
      };
      if (type == "down") {
        index = index + 1;
      }
      this.tableList.splice(index, 0, o);
      let copy = JSON.parse(JSON.stringify(this.tableList));
      this.tableList = [];
      this.$nextTick(() => {
        this.tableList = copy;
      });
    },
    getInvoiceType(value) {
      for (let i = 0; i < value.length; i++) {
        if (value[i].InvoiceTypeName == "收据") {
          this.data.InvoiceTypeName = value[i].InvoiceTypeName;
          this.data.InvoiceTypeId = value[i].InvoiceTypeId;
          return;
        } else {
          this.data.InvoiceTypeName = value[0].InvoiceTypeName;
          this.data.InvoiceTypeId = value[0].InvoiceTypeId;
        }
      }
    },
    openTradeunit() {
      if (!this.isSelect) {
        this.$refs.tradeunitDialog.open().then((that) => {
          that.getData({ TradeUnitTypes: [0, 2], Status: 1 });
        });
      }
    },
    previewNo(val = "") {
      this.code_api.previewNo("销货单", val).then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取销货单编码失败");
        }
      });
    },
    init() {
      this.callOptionApi();
      this.tradeUnitApi
        .list({ TradeUnitTypes: [0, 2], Status: 1 })
        .then((res) => {
          if (res.Code == 0) this.tradeUnitList = res.Data;
        });
      this.transportApi.list({}).then((res) => {
        if (res.Code == 0) this.transportList = res.Data;
      });
      this.pdApi
        .list({ Property: "销售", pageIndex: 1, pageSize: 7, Status: 1 })
        .then((res) => {
          this.DAccount = res.Data;
          this.initDAccount = res.Data;
          this.listTotal = res.Count;
          this.initTotal = res.Count;
        });
      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "销售发票";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.businessTypeApi
            .getSourceTypeToBusinessType(SourceTypeId)
            .then((res) => {
              if (res.Code == 0) {
                this.businessTypeList = res.Data;
                this.data.BusinessTypeId =
                  this.businessTypeList[0].BusinessTypeId;
                this.data.BusinessType = this.businessTypeList[0].BusinessType;
                this.data.MinusEntry = this.businessTypeList[0].MinusEntry;
                this.changeNumber(this.data.MinusEntry);
              }
            });
        }
      });
    },
    // integerQuantity(row,index){
    //   if(this.data.MinusEntry){
    //         row.SaQuantity=0-row.SaQuantity
    //         row.Quantity2=0-row.Quantity2
    //   }else{
    //         row.SaQuantity=Math.abs(row.SaQuantity)
    //         row.Quantity2=Math.abs(row.Quantity2)
    //   }
    // },
    createOrder() {
      const user = this.$store.state.user;
      if (user) {
        this.data.EmpId = user.empId;
        this.data.EmpName = user.name;
        this.data.MakeEmpId = user.id;
        this.data.MakeEmpName = user.name;
      }
      this.addList();
      this.previewNo();
    },
    editOrder(data, type = 0) {
      console.log("执行编辑", data);
      this.api.info(data).then((res) => {
        if (res.Code === 0) {
          this.isSave = true;
          this.data = res.Data;
          this.tableList = res.Data.ProductModels?.map(
            (item) => ((item.T = 3), item)
          );
        }
        if (type === 1) {
          this.Review();
        }
        if (res.Data.ProductModels.length == 0) this.addList();
      });
    },
    async toggleOrder() {
      const res = await this.sourceTypeApi.info("销售发票");
      let OrderType = res.SourceTypeId;
      let that = await this.$refs.saleSelect.open();
      that.setBypeId(this.data.BusinessTypeId);
      that.getData({ Status: 2, OrderType, BusinessTypeId: this.data.BusinessTypeId, });
    },
    // 获取进货单明细
    async setOrderList(data, type) {
      let Quantity = this.tableList.map((i) => i.ProductId);
      console.log("data", data);
      if (data.TradeUnitId > 0) {
        this.data.FullName = data.FullName;
        this.data.TradeUnitId = data.TradeUnitId;
      }
      const res = await this.sourceTypeApi.info("销货单");
      let SourceType = res.SourceTypeId;
      let addList = data.List.reduce((arr, item) => {
        if (!Quantity.includes(item.ProductId)) {
          let UnitType = 0;
          if (item.Units.length != 0) {
            UnitType = 1;
          }

          arr.push({
            ExistQuantity: 0,
            StockQuantity: 0,
            Requirement: "",
            ...item,
            SaUnitId: item.SaUnitId,
            SaUnitName: item.SaUnitName,
            WarehouseId: item.WarehouseId || null,
            DocProductId: 0,
            SourceType,
            SourceDocId: item.DocId,
            SourceDtsId: item.DocProductId,
            SourceDocNo: data.Order,
            UnitId2: item.UnitId2,
            UnitName2: item.UnitName,
            Units: item.Units,
            ChangeType: item.ChangeType,
            UnitType: UnitType,
          });
        } else {
          this.$message.warning("已有相同订单");
        }
        return arr;
      }, []);
      addList.forEach((item, i) => {
        item.ChangeType = 0;
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length > 0 && item.SaUnitId) {
          const findIndex = item.Units.findIndex(
            (el) => el.UnitId == item.SaUnitId
          );
          const IsMainIndex = item.Units.findIndex((el) => el.IsMain == true); //主单位的索引
          const UnitId2Index = item.Units.findIndex(
            (el) => el.UnitId == item.UnitId2
          ); //不是主单位的索引
          const noMainIndex = item.Units.findIndex((el) => el.IsMain == false);
          if (findIndex == IsMainIndex) {
            //判断当前销售单位是否为主单位
            item.Rate =
              item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex]
                .Rate || 0;
            item.ChangeType =
              item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex]
                .ChangeType || 0;
            item.IsMain = true;
          } else {
            //如果当前是赋单位
            item.Rate = item.Units[findIndex].Rate;
            item.ChangeType = item.Units[findIndex].ChangeType;
            item.IsMain = false;
          }

          this.changeQuantity(item.PuQuantity, item, i);
        } else {
          item.Units.forEach((v) => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType;
          });
        }
      });
      this.tableList.unshift(...addList);
      console.log("this.tableList", this.tableList);
      if (this.data.TradeUnitId) {
        this.isSelect = true;
      }
      // console.log('data',data);
      // console.log('addList',addList);
      // console.log("Quantity", this.tableList);
    },

    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage({ val, text1 }) {
      this.pageParams.pageIndex = val;
      this.pdApi
        .list({
          Property: "销售",
          pageIndex: val,
          pageSize: 7,
          Status: 1,
          ProductName: text1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: "销售",
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1,
        })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;
            this.listTotal = res.Count;
          }
        });
    },
    setProduct(row, index) {
      let data = this.productList.filter(
        (item) => item.ProductId === row.ProductId
      );
      this.tableList[index].ProductName = data[0].ProductName;
      this.tableList[index].ProductNo = data[0].ProductNo;
      this.tableList[index].ProductSpec = data[0].ProductSpec;
      this.tableList[index].SaUnitName = data[0].SaUnitName;
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    // 选择存货名称
    onSelect(e, row) {
      console.log("e", e);
      let Product = this.tableList.map((i) => i.ProductId);
      if (Product.includes(e.ProductId))
        return this.$message.warning("产品已存在");
      if (this.data.TradeUnitId === null)
        return this.$message.warning("请先选择客户");

      if (row.SourceDocNo && row.ProductId != e.ProductId) {
        // this.data.TradeUnitId = '';
        // this.data.FullName = '';
        // this.isSelect = false;
        // this.$nextTick(() => {
        //   this.$refs.ruleForm.clearValidate();
        // })
        row.SourceType = 0;
        row.SourceDocId = 0;
        row.SourceDtsId = 0;
        row.SourceDocNo = "";
      }
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1;
      
      row.HasGrammage = e.HasGrammage ?? false
      row.Grammage = e.Grammage ?? 0
      row.ProductNo = e.ProductNo;
      row.ProductName = e.ProductName;
      row.ProductId = e.ProductId;
      row.ProductSpec = e.ProductSpec;
      row.SaUnitId = e.SaUnitId;
      row.SaUnitName = e.SaUnitName;
      row.UseColor = e.UseColor;
      row.Colors = e.Colors;
      row.Units = e.Units;
      row.UnitType = 0;
      row.ExistQuantity = e.ExistQuantity;
      row.StockQuantity = e.StockQuantity;
      row.UnitId = e.SaUnitId;
      row.ChangeType = 0;
      if (e.Units.length === 0) {
        // row.UnitId2 = e.SaUnitId;
        // row.SaUnitName = e.SaUnitName;
        // row.UnitName2 = e.SaUnitName;
        // row.Rate = 1;
        row.UnitId2 = e.SaUnitId;
        // row.PuUnitName = e.PuUnitName;
        row.UnitName = e.PuUnitName;
        row.UnitId2 = 0;
        row.SaUnitName = e.SaUnitName;
        row.UnitName2 = "";
        row.Rate = 0;
        row.Quantity2 = 0;
      } else {
        row.UnitType = 1;
        e.Units.forEach((item) => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType;
        });
        if (row.SaUnitId) {
          let index = this.getUnitIndex(3, e.Units, row.SaUnitId);
          let data = this.getUnitValue(e.Units, index);
          let assistIndex = 0;
          let assistData = {};
          row.IsMain = data.IsMain;

          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = this.getIinvexchrate(assistData.Rate);
            

          } else {
            assistIndex = this.getUnitIndex(1, e.Units);
            assistData = this.getUnitValue(e.Units, assistIndex);
            row.Rate = this.getIinvexchrate(data.Rate);
          }
          row.UnitId2 = assistData.UnitId;
          row.UnitName2 = assistData.UnitName;
        } else {
          let untiLength = e.Units.length;
          let mainData = [];
          let noMainData = [];
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i]);
            } else {
              noMainData.push(e.Units[i]);
            }
          }
          row.SaUnitId = mainData[0].UnitId;
          row.SaUnitName = mainData[0].UnitName;
          row.UnitId2 = noMainData[0].UnitId;
          row.UnitName2 = noMainData[0].UnitName;
          row.Rate = this.getIinvexchrate(noMainData[0].Rate);
          row.IsMain = true;
        }
      }
      //   let _colorShow=this.tableList.find(item=>item.UseColor==true)

      //  if(_colorShow){
      //   this.tableColorShow=true
      //  }else{
      //   this.tableColorShow=false
      //  }
      this.productApi
        .productPrice({
          TradeUnitId: this.data.TradeUnitId,
          ProductId: e.ProductId,
        })
        .then((res) => {
          if (res.Data) {
            row.SalePrice = res.Data.SalePrice;
            row.RetailPrice = res.Data.RetailPrice;
            row.PurchasePrice = res.Data.PurchasePrice;
            row.QuotedPrice = res.Data.QuotationPrice;
            row.Price = res.Data.QuotationPrice;
            row.TaxPrice = res.Data.QuotationPrice;
          }
        });

      // this.api
      //   .productPrice({
      //     TradeUnitId: this.data.TradeUnitId,
      //     ProductId: e.ProductId,
      //   })
      //   .then((res) => {
      //     if (res.Data) {
      //       row.SalePrice = res.Data.SalePrice;
      //       row.RetailPrice = res.Data.RetailPrice;

      //     }
      //   });
    },
    RateChange(data, row, index) {
      if (data < 0 || data == "") return;
      if (row.T === 3) row.T = 1;
      this.changeQuantity(this.tableList[index].SaQuantity, row, index);
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList();
      }
    },

    compareSaUnit(data, row, index) {
      if (row.T === 3) row.T = 1;
      this.tableList[index].IsMain = data.IsMain;
      let findIndex = 0;
      if (row.SaUnitId == row.UnitId2) {
        let num = 0;
        num = row.SaQuantity;
        row.SaQuantity = row.Quantity2;
        row.Quantity2 = num;
        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeRightUnitId(index, findIndex, data.Rate);
        }
      }
      this.changeQuantity(this.tableList[index].SaQuantity, row, index);
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].UnitId2 =
        this.tableList[index].Units[findIndex].UnitId;
      this.tableList[index].UnitName2 =
        this.tableList[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableList[index].Rate = Rate;
      }
    },
    changeQuantity2(data, row, index) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      data = Number(this.getQuantity(data));
      row.Quantity2 = data;
      if (this.data.MinusEntry) {
        row.SaQuantity > 0
          ? (row.SaQuantity = 0 - row.SaQuantity)
          : row.SaQuantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.SaQuantity = Math.abs(row.SaQuantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data);
      }
      if (row.T === 3) row.T = 1;
      if (row.IsMain == false) {
        if (row.ChangeType == 1) {
          if (row.SaQuantity === "" || row.SaQuantity === 0) {
            return;
          }
          //row.Rate = this.getIinvexchrate(data / row.SaQuantity)
          if (row.HasGrammage == true) {
            row.SaQuantity = this.getQuantity(data * row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(data / row.SaQuantity)
          }
        } else {
          console.log("数量1=数量2/换算率");
          row.SaQuantity = this.getQuantity(data / row.Rate);
        }
      } else {
        if (row.ChangeType == 1) {
          if (row.SaQuantity === "" || row.SaQuantity === 0) {
            return;
          }
          //row.Rate = this.getIinvexchrate(row.SaQuantity / data)
          if (row.HasGrammage == true) {
            row.SaQuantity = this.getQuantity(data / row.Rate)
          } else {
            row.Rate = this.getIinvexchrate(row.SaQuantity / data)
          }
        } else {
          console.log("数量1=数量2*换算率");
          row.SaQuantity = this.getQuantity(data * row.Rate)
        }
      }
    },
    getChangeQuantity(data, row, index) {
      if (row.SaQuantity === "" || row.SaQuantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if (row.IsMain) {
            row.SaQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate))
          } else {
            row.SaQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate))
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {};
      data.UnitId = arr[findIndex].UnitId;
      data.UnitName = arr[findIndex].UnitName;
      data.IsMain = arr[findIndex].IsMain;
      data.ChangeType = arr[findIndex].ChangeType;
      data.Rate = arr[findIndex].Rate;
      return data;
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = "") {
      let index = 0;
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex((el) => el.IsMain == true);
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex((el) => el.IsMain == false);
      } else {
        //获取当前传入id的索引
        index = arr.findIndex((el) => id == el.UnitId);
      }
      return index;
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].SaUnitId =
        this.tableList[index].Units[findIndex].UnitId;
      this.tableList[index].SaUnitName =
        this.tableList[index].Units[findIndex].UnitName;
      if (Rate > 0) {
        this.tableList[index].Rate = Rate;
      }
    },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1;
      if (data.IsMain) {
        this.tableList[index].IsMain = false;
      } else {
        this.tableList[index].IsMain = true;
      }
      let findIndex = 0;
      if (row.SaUnitId == row.UnitId2) {
        let num = 0;
        num = row.SaQuantity;
        row.SaQuantity = row.Quantity2;
        row.Quantity2 = num;
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        }
      } else {
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex);
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units);
          this.changeLeftUnitId(index, findIndex, data.Rate);
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2, row, index);
    },
    changWarehouse(row) {
      if (row.T === 3) row.T = 1;
    },
    changeDeliveryDate(row) {
      if (row.T === 3) row.T = 1;
    },
    changeIsGift(data, row) {
      if (row.T === 3) row.T = 1;
      if (data) {
        row.QuotedPrice = 0;
        row.Discount = 0;
        row.TaxRate = 0;
        row.Price = 0;
        row.TaxPrice = 0;
        row.Amount = 0;
        row.TaxLimit = 0;
        row.TaxAmount = 0;
        row.DiscountAmount = 0;
      }
    },
    RestartOrder() {
      this.$message.success("新增");
      Object.assign(this.$data, this.$options.data.call(this));
      this.init();
      this.createOrder();
      this.addList();
      setTimeout(() => {
        this.$refs.ruleForm.clearValidate();
      }, 30);
    },

    orderUpdate() {
      this.$message.success("变更");
      this.is_orderUpdateStatus = true;
    },
    Review() {
      this.api.review(this.data.DocId).then((res) => {
        this.data.Status = 2;
        res.Code === 0
          ? this.$message.success(res.Msg)
          : this.$message.warning(res.Msg);

        if (res.Code === 0) {
          this.editOrder(this.data.DocId);
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      });
    },
    orderReview() {
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      const message =
        this.data.Status == 2 ? "确认要弃审吗？ " : "确认提交审核吗？";
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const data = this.data.Status == 2 ? "back" : "review";
          if (data === "review") {
            this.save(1);
          } else if (data === "back") {
            this.api[data](this.data.DocId).then((res) => {
              if (res.Code === 0 && data == "review") {
                this.data.Status = 2;
              }
              if (res.Code === 0 && data == "back") this.data.Status = 0;
              res.Code === 0
                ? this.$message.success(res.Msg)
                : this.$message.warning(res.Msg);

              if (res.Code === 0) {
                this.editOrder(this.data.DocId);
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            });
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.DocId == 0) {
        this.$message.warning("订单未保存");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.api.delete({ Id: this.data.DocId }).then((res) => {
            if (res.Code === 0) this.RestartOrder();
            res.Code === 0
              ? this.$message.success(res.Msg)
              : this.$message.warning(res.Msg);
          });
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    delTableList(data, index) {
      // if (data.SourceDocNo) {
      //   // this.data.TradeUnitId = '';
      //   this.data.FullName = '';
      //   this.isSelect = false;
      //   this.$nextTick(() => {
      //     this.$refs.ruleForm.clearValidate();
      //   })
      // }
      // this.$message.success("删除");
      this.tableList.splice(index, 1);
      if (this.tableList.length === 0) this.addList();
      if (this.tableList.length === 1) {
        this.isSelect = false;
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setEmp(data) {
      console.log(data);
      this.data.EmpId = data.EmpId;
      this.data.EmpName = data.EmpName;
      this.data.DpId = data.DpId;
      this.data.DpName = data.DpName;
      this.data.DpNo = data.DpNo;
    },

    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.PropertyId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
    //单据保存回显
    initerPrice(price) {
      this.currentRow.Price = price;
      this.changePrice(this.currentRow, this.currentIndex);
    },
    openSales(row, index) {
      this.currentRow = row;
      this.currentIndex = index;
      let ProductName = row.ProductName;
      let TradeUnitName = this.data.TradeUnitName;
      this.$refs.orderDialog.open().then((that) => {
        that.setData(ProductName, TradeUnitName);
      });
      // this.$refs.orderDialog.open();
    },

    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.FullName = data.FullName;
      // this.data.TradeUnitId = data.TradeUnitId;
      // this.data.FullName = data.SettleFullName;
      this.data.TradeUnitType = data.TradeUnitType;
    },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.DocId == 0 || row.OrderProductId == 0)
        return (row.LineAbort = false);
      this.api
        .lineAbort({
          Id: row.OrderProductId,
          IsLineAbort: data,
        })
        .then((res) => {
          if (res.Code === 1) {
            row.LineAbort = !data;
            return this.$message.error(res.Msg);
          }
        });
    },

    changeColor(row, index) {
      if (row.T === 3) this.tableList[index].T = 1;
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1;
      if (!Number(row.SaQuantity)) {
        this.$message.warning("请先填写数量");
        return true;
      }
      return false;
    },

    changeQuantity(data, row, index) {
      if (data == "-" || data == "." || data == "") {
        return;
      }
      data = this.getQuantity(data);
      row.SaQuantity = data;
      if (this.data.MinusEntry) {
        row.SaQuantity > 0
          ? (row.SaQuantity = 0 - row.SaQuantity)
          : row.SaQuantity;
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2;
        data = data > 0 ? 0 - data : data;
      } else {
        row.SaQuantity = Math.abs(row.SaQuantity);
        row.Quantity2 = Math.abs(row.Quantity2);
        data = Math.abs(data);
      }
      if (row.T == 3) this.tableList[index].T = 1;
  
      if (row.IsMain) {
        if (row.HasGrammage == true) {
          row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
        } else {
          row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
        }
      } else {
        if (row.HasGrammage == true) {
          row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
        } else {
          row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
        }
      }

      // 金额
      if (Number(row.Price)) {
        let Amount =
          Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount =
          (Number(row.QuotedPrice) - Number(row.Price)) * Number(data);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }
    },
    // 报价
    changeQuotedPrice(row, index) {
      // row.QuotedPrice=parseFloat(row.QuotedPrice)
      if (row.T === 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice;
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price)

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount =
          (Number(row.QuotedPrice) - Number(row.Price)) *
          Number(row.SaQuantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) *
          Number(row.SaQuantity) *
          (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index, "Discount")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice;
      this.tableList[index].Price = Price < 0 ? 0 : Number(this.getPrice(Price))

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      //修改含税单价
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount =
          (Number(row.QuotedPrice) - Number(row.Price)) *
          Number(row.SaQuantity);
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) *
          Number(row.SaQuantity) *
          (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit.toFixed(2);
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价
    changePrice(row, index) {
      if (this.validInput(row, index, "Price")) return;

      row.Price= this.getPrice(row.Price)

      if (row.T == 3) this.tableList[index].T = 1;
      let quantityNum = 0;

      if (row.Units.length === 0) {
        quantityNum = row.SaQuantity;
      } else {
        if (row.IsMain) {
          quantityNum = row.SaQuantity;
        } else {
          quantityNum = row.Quantity2;
        }
      }
      row.quantityNum = quantityNum;

      let rate = null;

      if (
        row.QuotedPrice == 0 ||
        row.QuotedPrice == null ||
        row.QuotedPrice == ""
      ) {
        rate = this.tableList[index].Discount / 100;
        if (rate === 1) {
          row.QuotedPrice = row.Price;
        } else {
          row.QuotedPrice = Number((row.Price * row.Discount).toFixed(2));
        }
      } else {
        rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100;
        this.tableList[index].Discount = Number(rate.toFixed(5));
      }

      row.changeMode = 1;

      // 修改单价
      let equation = null;
      if (row.Discount == 100) {
        equation = Number(row.QuotedPrice);
      } else {
        equation = row.Price;
      }

      // 金额
      if (Number(row.quantityNum)) {
        console.log("row.quantityNum", row.quantityNum);
        let Amount = equation * Number(row.quantityNum);
        console.log("equation", equation);
        this.tableList[index].Amount = Number(Amount.toFixed(2));
      }

      // 修改含税单价
      let TaxPrice = (equation * (100 + Number(row.TaxRate))) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // this.changeDiscount(row, index);

      if (Number(row.QuotedPrice)) {
        // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
        // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - equation) * row.quantityNum;

        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
      }
      if (Number(row.TaxRate)) {
        let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, "TaxRate")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      row.TaxRate = this.getIinvexchrate(row.TaxRate)
      // 修改税额
      let TaxLimit =
        Number(row.Price ?? 0) *
        Number(row.SaQuantity) *
        ((row.TaxRate ?? 0) / 100);
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2));

      // 修改含税单价
      let TaxPrice = (row.Price * (100 + Number(row.TaxRate))) / 100;
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0);
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, "TaxPrice")) return;
      if (row.T == 3) this.tableList[index].T = 1;
      // 修改单价
      let Price = row.TaxPrice / (1 + row.TaxRate / 100);
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 修改金额
      let Amount =
        Number(row.Price) * Number(row.SaQuantity) * (row.Discount / 100);
      this.tableList[index].Amount = Number(Amount.toFixed(2));

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      if (Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) *
          Number(row.SaQuantity) *
          (Number(row.TaxRate) / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, "TaxLimit")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      if (row.changeMode === 0 || row.changeMode == null) {
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit);
        this.tableList[index].Amount = Number(Amount.toFixed(2));

        // 修改单价
        let Price = Number(row.Amount) / Number(row.SaQuantity);
        this.tableList[index].Price = Number(this.getPrice(Price))

        // this.changePrice(row, index)

        // 修改折扣率
        let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100;
        this.tableList[index].Discount = Number(rate.toFixed(5));

        // 修改含税单价
        let TaxPrice =
          (Number(row.Price) * (100 + Number(row.TaxRate ?? 0))) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

        // 折扣金额
        let DiscountAmount = 0;
        DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

        // 修改含税金额
        if (Number(row.TaxLimit) || Number(row.Amount)) {
          let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
          this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
        }
      } else {
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity);
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, "Amount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity);
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改报价
      if(Number(this.tableList[index].Discount) === 100){
        row.QuotedPrice = this.tableList[index].Price;
      }

      // 修改折扣率
      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));

      // this.changePrice(row, index)
      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      }

      // 修改税额
      if (Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, "TaxAmount")) return;

      if (row.T == 3) this.tableList[index].T = 1;

      row.changeMode = 0;

     // 修改金额
     let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
      this.tableList[index].Amount = Number(Amount.toFixed(2));


      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      let rate = Number(row.Price) / Number(row.QuotedPrice)  * 100 
      this.tableList[index].Discount = Number((rate).toFixed(2));

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity)
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : this.getPrice(TaxPrice)


       // 折扣金额
      let DiscountAmount = 0;
      DiscountAmount = (row.QuotedPrice - Number(row.Price))  * row.SaQuantity;
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2));
    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, "DiscountAmount")) return;
      if (row.T == 3) this.tableList[index].T = 1;

      // 修改单价
      let Price = row.QuotedPrice - row.DiscountAmount / row.SaQuantity;
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率

      let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100;
      this.tableList[index].Discount = Number(rate.toFixed(5));

      // 金额
      let Amount =
        Number(row.Price) *
        Number(row.SaQuantity) *
        (Number(row.Discount) / 100);
      this.tableList[index].Amount = Amount.toFixed(2);

      // 修改含税单价
      if (Number(row.TaxRate)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100;
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      }

      // 修改税额
      if (Number(row.TaxRate)) {
        let TaxLimit =
          Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100);
        this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2));
        // this.changeTaxRate(row, index);
      }

      // 修改含税金额
      if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit);
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2));
      }
    },
    // 单价弹窗
    renderHeader(h, { column }) {
      return h("div", [
        h("span", column.label),
        h("i", {
          class: "el-icon-s-order",
          style: "font-size:14px;cursor: pointer;",
          on: {
            click: this.openSales,
          },
        }),
      ]);
    },
    openPrint() {
      this.columnkey = saleList.Data.map((i) => i.tableName);
      this.columns = saleList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label };
        acc.push({ label: item.label, data: print });
        return acc;
      }, []);
      this.formData = saleList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName],
        });
      }, []);
      this.$refs.printDialog.open();
      s;
    },
    save(type = 0) {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return false;
        const Product = JSON.parse(JSON.stringify(this.data.ProductModels));
        const TableList = JSON.parse(JSON.stringify(this.tableList));

        var btId = 0;
        var obj = this.businessTypeList.find(x => x.BusinessType == "销售退货");
        if(obj) btId = obj.BusinessTypeId;
        // 清除没有产品的数据
        this.tableList = this.tableList.filter((i) => i.ProductId != 0);
        for (let i = 0; i <= this.tableList.length - 1; i++) {
          if(this.data.BusinessTypeId == btId && btId) {
            if (this.tableList[i].Amount > 0) {
              this.$message({ type: "warning", message: "金额不能大于0" });
              return;
            }
          } else {
            if (this.tableList[i].Amount < 0) {
              this.$message({ type: "warning", message: "金额不能小于0" });
              return;
            }
          }
          if (
            this.tableList[i].SaQuantity == null ||
            this.tableList[i].SaQuantity == 0
          )
            return this.$message.warning("数量不能为空并且不为0");
          if (!this.tableList[i].UnitId2 && this.tableList[i].UnitType)
            return this.$message.warning("计量单位2不能为空");
          if (
            this.tableList[i].UseColor &&
            (this.tableList[i].ColorId === 0 ||
              this.tableList[i].ColorId == null)
          ) {
            this.$message.error(
              `存货${this.tableList[i].ProductName}未填写颜色`
            );
            return;
          }
        }
        if (this.tableList.filter((i) => i.DeliveryDate == "").length !== 0)
          return this.$message.warning("交货日期不能为空");
        //

        if (this.data.ProductModels.length > 0) {
          let delIds = this.tableList.map((item) => item.ProductId);
          let delList = this.data.ProductModels.reduce((arr, item) => {
            if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
            return arr;
          }, []);

          let addIds = this.data.ProductModels.map((item) => item.ProductId);
          let addList = [];
          addList = this.tableList.reduce((arr, item) => {
            if (!addIds.includes(item.ProductId)) arr.push({ ...item, T: 0 });
            return arr;
          }, []);

          let updateList = this.data.ProductModels.filter((i) => i.T == 1);
          this.data.ProductModels = [...addList, ...delList, ...updateList];
        } else {
          this.data.ProductModels = this.tableList;
        }
        //
        this.data.DeliveryDate = this.data.DocDate;
        console.log("保存前", this.data);
        // var data = this.$commonJs.obj.removeNullKey(this.data);
        // this.data.Requirement = "";
        // if(this.data.SettleId==null)this.data.SettleId=0
        // if(this.data.BusinessTypeId==null)this.data.BusinessTypeId=0
        // if(this.data.InvoiceTypeId==null)this.data.InvoiceTypeId=0
        // this.data.ProductModels.forEach(item=>{
        //   if(item.ColorId==null)item.ColorId=0
        //   if(item.WarehouseId==null)item.WarehouseId=0
        // })
        var sub = {
          ...this.data,
          SettleId: this.data.SettleId || 0,
          BusinessTypeId: this.data.BusinessTypeId || 0,
          InvoiceTypeId: this.data.InvoiceTypeId || 0,
        };
        sub.ProductModels.forEach((item) => {
          if (item.ColorId == null) item.ColorId = 0;
          if (item.WarehouseId == null || item.WarehouseId == "")
            item.WarehouseId = 0;
        });
        // 等于空设置为0
        sub.ProductModels.forEach((item) => {
          Object.keys(item).forEach((key) => {
            if (
              item[key] == null &&
              key !== "LineAbortDate" &&
              key !== "DeliveryDate"
            ) {
              item[key] = 0;
            }
          });
        });
        this.api
          .save(sub)
          .then((res) => {
            if (res.Code === 0) {
              const id = res.Data === 0 ? this.data.DocId : res.Data;
              this.isSave = true;
              this.is_orderUpdateStatus = false;
              this.editOrder(id, type);
              if (type !== 1) {
                this.$message.success("保存成功");
              }
            }
            if (res.Code === 1) {
              this.tableList = TableList;
              this.ProductModels = Product;
              this.data.ProductModels = Product;
              this.$message.error(res.Msg);
            }
          })
          .catch((err) => {
            this.tableList = TableList;
            this.ProductModels = Product;
            this.data.ProductModels = Product;
          });
      });
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1;
      }
    },
    addList() {
      this.tableList.push({
        T: 0,
        DocProductId: 0,
        ExistQuantity: null,
        StockQuantity: null,
        SourceDocId: 0,
        SourceDtsId: 0,
        SourceType: 0,
        OrderId: 0,
        OrderProductId: 0,
        WarehouseId: "",
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: null,
        UnitId2: "",
        Quantity2: null,
        Rate: null,
        QuotedPrice: null,
        Discount: 100,
        TaxRate: null,
        Price: null,
        TaxPrice: null,
        Amount: null,
        TaxAmount: null,
        TaxLimit: null,
        DiscountAmount: null,
        DeliveryDate: "",
        IsGift: false,
        CostPrice: null,
        CostAmount: null,
        OutQuantity: null,
        OutQuantity2: null,
        InvoicedQuantity: null,
        InvoicedQuantity2: null,
        ReturnQuantity: null,
        SettlementAmount: null,
        PriceStrategyId: 0,
        ReceiptAmount: null,
        DocNo: "",
        DocDate: "",
        ColorName: "",
        ProductNo: "",
        ProductType: 0,
        ProductName: "",
        ShortName: "",
        ProductSpec: "",
        Property: "",
        UnitName2: "",
        SaUnitName: "",
        OrderNo: "",
        WarehouseName: "",
        WarehouseNo: "",
        InvoiceTypeName: "",
        TradeUnitId: 0,
        TradeUnitNo: "",
        FullName: "",
        Remark: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
